import { Value } from "@scalar/typebox/value";
const coerceValue = (schema, value) => Value.Cast(schema, value);
export {
  coerceValue
};
//# sourceMappingURL=typebox-coerce.js.map
